import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

export function Talks() {
  return (
    <section id="talks" className="md-section">
      <div className="md-container">
        <SectionHead num="07" eyebrow="Talks" title="Spoken in public, occasionally." />
        <div className="md-card md-card--filled">
          {portfolio.talks.map((t, i) => (
            <div key={i} className="m3-pub__row" style={{ padding: "20px 24px" }}>
              <div
                className="m3-pub__icon"
                style={{
                  background: "var(--md-sys-color-secondary-container)",
                  color: "var(--md-sys-color-on-secondary-container)",
                }}
              >
                <span className="material-symbols-rounded">mic</span>
              </div>
              <div>
                <div className="md-title-m">{t.title}</div>
                <div className="md-label-l m3-pub__venue">{t.venue}</div>
                {t.note && (
                  <div className="md-body-s dim" style={{ marginTop: 4 }}>
                    {t.note}
                  </div>
                )}
              </div>
              <div
                className="m3-pub__year"
                style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "flex-end" }}
              >
                <span className="md-body-m">{t.year}</span>
                {t.href && (
                  <a
                    className="md-btn md-btn--filled"
                    href={t.href}
                    target="_blank"
                    rel="noreferrer"
                    style={{ height: 36, padding: "0 16px" }}
                  >
                    View
                    <span className="material-symbols-rounded">arrow_outward</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
